import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ConfigProvider } from "antd";

import { Provider } from "react-redux";
import store from "./redux/store";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const PUBLIC_KEY =
  "pk_test_51Lc0KeSDcM74kosWFIvJyWfAkBQM4DfgcTnJC9rMETOyuWAnHmovkwSk8wQYCgNXRbpuajbT4mKMKwR2zJup9t5w00JFDP42FA";

const stripeTestPromise = loadStripe(PUBLIC_KEY);

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <Elements stripe={stripeTestPromise}>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: "#fc8680",
            },
          }}
        >
          <App />
        </ConfigProvider>
      </Elements>
    </React.StrictMode>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
